import { render, staticRenderFns } from "./baseCustServReport.vue?vue&type=template&id=35ad887e&scoped=true&"
import script from "./baseCustServReport.vue?vue&type=script&lang=js&"
export * from "./baseCustServReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad887e",
  null
  
)

export default component.exports